import React from "react";
import { TurnrModalContent, TurnrModalHeader } from "~/components/modals/TurnrModal";
import OneClickOptionsWrapper, { OneClickTextOption } from "../../OneClickOptions";
import { getProductComplaintReason, getProductComplaintReasons } from "~/cores/productCore";
import { getReturnReasonTranslated } from "~/cores/appCore";
import { getSubReasons } from "backoffice/src/cores/returnReasonCore.js";

export default function ComplaintStepSubReason({ appProps, complaintStepperProps }) {
    const { getLocaleText, language } = appProps;

    const { onBack, onModalClose, product, selectedComplaintReasonId, onComplaintSubReasonSelected } = complaintStepperProps;

    const complaintReason = getProductComplaintReason(product, { complaintReasonId: selectedComplaintReasonId });
    const subComplaintReasons = getSubReasons({ returnReason: complaintReason });
    const complaintReasons = getProductComplaintReasons(product);

    return (
        <>
            <TurnrModalHeader onBack={onBack} onClose={onModalClose} title={getLocaleText("complaint-type-title")} />
            <TurnrModalContent>
                <OneClickOptionsWrapper>
                    {subComplaintReasons?.map((subComplaintReason) => {
                        const complaintReasonId = subComplaintReason?.id;
                        const complaintLabel = getReturnReasonTranslated({
                            returnReason: subComplaintReason,
                            language,
                        });
                        return (
                            <OneClickTextOption key={complaintReasonId} dataTestId={`complaint-reason-${complaintReasonId}`} onClick={() => onComplaintSubReasonSelected(complaintReasonId)}>
                                {complaintLabel}
                            </OneClickTextOption>
                        );
                    })}
                    {getLocaleText("complaint-reasons-post-message")}
                </OneClickOptionsWrapper>
            </TurnrModalContent>
        </>
    );
}
